import React, { useRef } from "react";

import BasketButton from "theme/components/buttons/functionalButtons/BasketButton";
import LogoLink from "../sharedComponents/LogoLink";
import Row from "theme/layouts/Row";
import Search from "../sharedComponents/Search";
import TopNavigation from "./TopNavigation";
import styled from "theme/libs/styled";
import toggleSearch from "core-web/state/models/Header/dispatches/toggleSearch";
import { useSelector } from "react-redux";
import SiteSelector from "theme/overlays/Navigation/SiteSelector";

const shouldForwardProp = (prop) => ["searchIsOpen"].indexOf(prop) === -1;

const Header = styled("header")`
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
    transition: transform ${({ theme }) => theme.transitions.primary};
`;

const HeaderInner = styled("div", { shouldForwardProp })`
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: 12px;
    padding: 8px 40px;
    margin: 0 8px;
    border-radius: 0 0 12px 12px;
    background: ${({ theme }) => theme.colors.white};
    box-shadow: 0px 4px 36px 0px rgba(0, 0, 0, 0.04);
`;

const MenuAndSearchWrapper = styled("div", { shouldForwardProp })`
    display: grid;
    grid-template-columns: ${({ searchIsOpen }) => (searchIsOpen ? "auto 100%" : "auto 43px")};
    align-items: center;
    transition: grid-template-columns ${({ theme }) => theme.transitions.primary};
`;

const DesktopNavbar = () => {
    const headerRef = useRef();
    const ecommerceEnabled = useSelector(({ application }) => application?.ecommerceEnabled);

    const { searchIsOpen } = useSelector(({ header }) => header.states);
    return (
        <Header ref={headerRef}>
            <HeaderInner>
                <LogoLink />

                <MenuAndSearchWrapper searchIsOpen={searchIsOpen}>
                    <TopNavigation />
                    <Search />
                </MenuAndSearchWrapper>
                <Row alignItems="center" gap="16px">
                    <SiteSelector />
                    {ecommerceEnabled && <BasketButton handleBasketClick={() => toggleSearch(false)} />}
                </Row>
            </HeaderInner>
        </Header>
    );
};

export default DesktopNavbar;
